import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=086e998d&"
import script from "./mainBody.vue?vue&type=script&lang=js&"
export * from "./mainBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports